import { createStore, createHook } from '@atlassian/react-sweet-state';
import type { InsightObjectViewState } from '../../common/types/index.tsx';
import * as actions from './actions/index.tsx';
import {
	getObjectDetails,
	getObjectConfiguration,
	getObjectSchemaId,
	getObjectSchemaName,
	getHasDeveloperRoleForObjectType,
	getHasManagerRoleForObjectType,
	getLabelAttribute,
	getEditableAttributesTypes,
	getAttribute,
	getAttributes,
	getIsRestrictedSchema,
	getObjectTypeId,
	getObjectId,
	getCmdbAnalyticAttributes,
} from './selectors.tsx';

export type Actions = typeof actions;

const initialState: InsightObjectViewState = {
	objectDetails: null,
	objectConfiguration: null,
	loading: false,
	error: null,
	isCompact: false,
	hideEmptyAttributes: false,
};

export const Store = createStore<InsightObjectViewState, Actions>({
	initialState,
	actions,
	name: 'object-details',
});

export const useObjectStoreState = createHook(Store);

export const useObjectActions = createHook(Store, {
	selector: null,
});

export const useObjectDetails = createHook(Store, {
	selector: getObjectDetails,
});

export const useObjectId = createHook(Store, {
	selector: getObjectId,
});

export const useObjectTypeId = createHook(Store, {
	selector: getObjectTypeId,
});

export const useObjectConfiguration = createHook(Store, {
	selector: getObjectConfiguration,
});

export const useObjectSchemaId = createHook(Store, {
	selector: getObjectSchemaId,
});

export const useObjectSchemaName = createHook(Store, {
	selector: getObjectSchemaName,
});

export const useCanEditObject = createHook(Store, {
	selector: getHasDeveloperRoleForObjectType,
});

export const useCanDeleteObject = createHook(Store, {
	selector: getHasManagerRoleForObjectType,
});

export const useLabelAttribute = createHook(Store, {
	selector: getLabelAttribute,
});

export const useEditableAttributeTypes = createHook(Store, {
	selector: getEditableAttributesTypes,
});

export const useAttribute = createHook(Store, {
	selector: getAttribute,
});

export const useAttributes = createHook(Store, {
	selector: getAttributes,
});

export const useIsRestrictedSchema = createHook(Store, {
	selector: getIsRestrictedSchema,
});

export const useCmdbAnalyticAttributes = createHook(Store, {
	selector: getCmdbAnalyticAttributes,
});
